import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

interface UseSubmitAgreementsParams {
  token: string;
  skuIds: string[];
}

export const submittedAgreements = ({
  token,
  skuIds,
}: UseSubmitAgreementsParams) => {
  return async () => {
    try {
      await axios.post(
        `${getBaseUrl(Microservice.SKU_FINANCE)}/sku-finance/sn/sku-loans-docs-signed`,
        {
          skuIds,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      const error = getApiResponseErrorMsg(e);
      (e as Error).message = error;
      throw error;
    }
  };
};
